import React from 'react';

import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';

import css from './style.module.scss';

import Notification from './Notification';

import { useAppSelector } from '../../../store/hooks';
import { notificationsSelector } from '../../../store/selectors/notifications';

const Notifications = () => {
  const notifications = useAppSelector(notificationsSelector);

  return (
    <>
      {notifications && notifications.length > 0 && (
        <div className={css.notifications}>
          <Actions gap="16" direction="column">
            {notifications.map((notification) => (
              <ActionsItem key={notification.id}>
                <Notification notification={notification} />
              </ActionsItem>
            ))}
          </Actions>
        </div>
      )}
    </>
  );
};

export default Notifications;
